// extracted by mini-css-extract-plugin
export default {"header":"SecondHeader_header__B5Xmg","logo":"SecondHeader_logo__FGTAG"};